import { render, staticRenderFns } from "./LmSendOTP.vue?vue&type=template&id=7e353ad1&scoped=true&"
import script from "./LmSendOTP.vue?vue&type=script&lang=js&"
export * from "./LmSendOTP.vue?vue&type=script&lang=js&"
import style0 from "./LmSendOTP.vue?vue&type=style&index=0&id=7e353ad1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e353ad1",
  null
  
)

export default component.exports